import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import './CreatorOnboardingBackgroundImage.scss';
import icons from '../../static/icons';
import { DEVICE_WIDTH_BREAKPOINTS } from '../../Helpers/constants';

// Not ideal to check inner width in js like this, but the alternative would require messy css
// transformations to get the different positioning/zoom effects on mobile vs desktop.
export const CREATOR_ONBOARDING_BACKGROUND_IMAGE_URL = window.innerWidth <= DEVICE_WIDTH_BREAKPOINTS.SM
  ? 'https://static.shopmy.us/Onboarding/Creator/creator-onboarding-background-mobile.jpg'
  : 'https://static.shopmy.us/Onboarding/Creator/creator-onboarding-background-desktop.jpg';

export const CreatorOnboardingBackgroundImageStyle = {
  FULL_WIDTH_CLEAR: 'full-width-clear',
  FULL_WIDTH_BLURRED: 'full-width-blurred',
};

const CreatorOnboardingBackgroundImage = props => {
  const { backgroundImageStyle } = props;
  const shopMyLogo = icons.brand.full_logo;

  return (
    <>
      <img 
        src={CREATOR_ONBOARDING_BACKGROUND_IMAGE_URL} 
        alt='Creator Onboarding Background Image'
        className={cn(
          'creator-onboarding-background-image',
          backgroundImageStyle
        )} 
      />
      <img
        src={shopMyLogo}
        alt='ShopMy Logo'
        className={cn(
          'creator-onboarding-background-image-logo',
          backgroundImageStyle
        )}
      />
    </>
  );
}

CreatorOnboardingBackgroundImage.propTypes = {
  backgroundImageStyle: PropTypes.oneOf(Object.values(CreatorOnboardingBackgroundImageStyle))
}

export default CreatorOnboardingBackgroundImage;
